<script setup>
import { defineProps, defineEmits, ref } from 'vue';
import Checkbox from '@/components/checkbox.vue';

const props = defineProps({
    show: {
        tyoe: Boolean,
        default: false
    }
})
const isConfirmed = ref(false);

const emit = defineEmits(['review', 'close']);

const handleConfirm = (action) => {
    emit('review', action);
}

</script>

<template>
    <Teleport to="body">
        <div v-if="props.show" class="modal-overlay" data-modal>
            <div ref="modalRef" class="modal">
                <div class="modal__header">
                    <h2 class="modal__title">Review Proposal</h2>
                    <button class="text-white bg-transparent hover:bg-white/10 hover:text-red-600 transition-colors duration-300 ease-in-out rounded-full text-sm p-0.5 ms-auto inline-flex items-center absolute -right-7 top-1" @click="emit('close')">
                        <svg class="size-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div class="modal__description">
                    <div>Approving assigns this RFP to a single seller and locks reward</div>
                </div>
                <div class="flex items-start gap-2 mt-6 px-2 mb-4">
                    <Checkbox v-model="isConfirmed" required />
                    <div class="flex flex-col">
                        <span for="confirmBid" class="text-sm text-echoes-primary font-semibold">Confirm Review Proposal</span>
                        <span class="text-xs text-gray-500">I agree woth the above and with the 
                            <a href="https://portexai.com/tou" target="_blank" class="hover:text-echoes-primary underline">Terms of Use</a></span>
                    </div>
                </div>
                <div class="modal__footer">
                    <button class="px-4 py-2 rounded-lg hover:bg-white/10" :class="isConfirmed ? 'text-white' : 'text-white/50 cursor-not-allowed'" @click="handleConfirm('rejected')" :disabled="!isConfirmed">Reject</button>
                    <button class="text-white px-4 py-2 rounded-lg" :class="isConfirmed ? 'bg-echoes-primary' : 'bg-echoes-primary/50 cursor-not-allowed'" @click="handleConfirm('approved')" :disabled="!isConfirmed">Accept</button>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped lang="postcss">
.modal-overlay {
    @apply fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-2;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.2s ease;
    isolation: isolate;
}

.modal {
    @apply bg-echoes-background-gray border border-echoes-border-gray/50 rounded-xl shadow-xl max-h-[85vh] mt-16 flex flex-col w-1/3 px-8;
    animation: slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    z-index: 1;
}

.modal__header {
    @apply sticky top-0 z-10 flex items-center justify-between pt-4 p-2 border-b border-echoes-border-gray bg-echoes-background-gray rounded-t-xl;
}

.modal__title {
    @apply text-xl font-semibold text-white flex items-center gap-2;
}

.modal__description {
    @apply px-2 bg-echoes-background-gray rounded-b-xl text-sm text-white/60;
}

.modal__footer {
    @apply px-4 bg-echoes-background-gray rounded-b-xl text-sm text-white/60 flex justify-center my-4 gap-4;
}
</style>